import styles from "../edit-camera.module.css";

import { inject, observer } from "mobx-react";
import { CameraDataStore, emptyLocation } from "../../../store/store";
import { runInAction } from "mobx";
import LocationSelectorStore from "../../../../../store/location-selector-store";
import { TreeNodeItem } from "../../../../../components/tree-select/TreeSelect";
import LocationSelector, {
    LocationItem,
} from "../../../../../components/location-selector/LocationSelector";
import { ILocationData } from "../../../store/types";
import { useEffect } from "react";

interface EditCameraLocationProps {
    cameraDataStore?: CameraDataStore;
    locationSelectorStore?: LocationSelectorStore;
}

function EditCameraLocation(props: EditCameraLocationProps) {
    const cameraDataStore = props.cameraDataStore!;
    const locationSelectorStore = props.locationSelectorStore!;
    const locationList = cameraDataStore.selectedCamera.locations;

    const render = () => {
        return (
            <>
                {locationList.map((element: ILocationData, index) => {
                    const locationId = Number(element.locationId);
                    const locationDropdownData =
                        buildLocationDropdownData(locationId);
                    const hasNoEmptyLocationItem =
                        locationSelectorStore.selectedIds.length !== 0;

                    if (
                        hasNoEmptyLocationItem &&
                        locationId === 0 &&
                        locationDropdownData.length != 0
                    ) {
                        locationList[index].locationId =
                            locationDropdownData[0].locationId;
                        locationList[index].locationName =
                            locationDropdownData[0].locationName;
                        locationList[index].locationPath =
                            locationDropdownData[0].areaName;
                        locationList[index].distance = 0;
                    }

                    return (
                        <div key={index} className={styles["room-field"]}>
                            <LocationSelector
                                mandatory
                                selectedId={locationId}
                                locationList={locationDropdownData}
                                onValueChange={(value: LocationItem) => {
                                    onLocationChange(
                                        element.listUniqueId!,
                                        Number(value.locationId) || 0
                                    );
                                }}
                                noEmptyLocationItem={hasNoEmptyLocationItem}
                            />
                        </div>
                    );
                })}
            </>
        );
    };

    const onLocationChange = (componentId: number, newLocationId: number) => {
        const availableLocations = locationSelectorStore.selectedRoomList;

        const elementIndex = cameraDataStore.selectedCamera.locations.findIndex(
            (locDist: ILocationData) => locDist.listUniqueId === componentId
        );

        if (newLocationId === 0) {
            cameraDataStore.selectedCamera.locations.splice(elementIndex, 1, {
                ...emptyLocation,
                listUniqueId: componentId,
            });
        } else {
            const newLocation = availableLocations.find((loc: TreeNodeItem) => {
                return Number(loc.id) === Number(newLocationId);
            });

            runInAction(() => {
                cameraDataStore.selectedCamera.locations[elementIndex] = {
                    ...cameraDataStore.selectedCamera.locations[elementIndex],
                    locationId: newLocation!.id,
                    locationName: newLocation!.name,
                    locationPath: newLocation!.path!,
                    distance:
                        cameraDataStore.selectedCamera.locations[elementIndex]
                            .distance,
                };
            });
        }

        cameraDataStore!.setSelectedCameraHasChanges(true);
        cameraDataStore!.validateSelectedCamera();
        cameraDataStore!.setValidated(true);
    };

    const buildLocationDropdownData = (selectedId?: any) => {
        const usedLocationIds = cameraDataStore.selectedCamera.locations.map(
            (location) => {
                return Number(location.locationId);
            }
        );

        const dropdownData = locationSelectorStore.selectedRoomList
            .map((room: TreeNodeItem) => {
                return {
                    locationId: room.id,
                    locationName: room.name,
                    areaName: room.path || "",
                };
            })
            .filter((location) => {
                return (
                    !usedLocationIds.includes(Number(location.locationId)) ||
                    Number(location.locationId) === Number(selectedId)
                );
            });

        return dropdownData;
    };

    return render();
}

export default inject(
    "cameraDataStore",
    "locationSelectorStore"
)(observer(EditCameraLocation));
